import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getFeedbackBorderBackgroundColors, getFeedbackBorderColors, getFeedbackIcon, getFeedbackMessageColors } from '../../utils';

export type FeedbackBannerVariant = 'error' | 'warning' | 'confirmation';

@Component({
    standalone: false,
    selector: 'app-feedback-banner',
    templateUrl: './feedback-banner.component.html'
})
export class FeedbackBannerComponent {
    @Input() variant: FeedbackBannerVariant = 'confirmation';
    @Input() header?: string;
    @Input() message: string;
    @Input() date?: string;
    @Input() showCloseIcon = false;
    @Input() showColoredBorder = false;
    @Output() closeMessage = new EventEmitter<void>();

    onCloseMessageClick() {
        this.closeMessage.emit();
    }

    protected readonly getFeedbackBorderBackgroundColors = getFeedbackBorderBackgroundColors;
    protected readonly getFeedbackMessageColors = getFeedbackMessageColors;
    protected readonly getFeedbackIcon = getFeedbackIcon;

    protected get getFeedbackBorderColors() {
        return getFeedbackBorderColors(this.variant);
    }
}
